export default "__VITE_ASSET__f130f73f__"